import axios from 'axios'
import moment from 'moment'
import Loader from '@/components/Loader/Loader.vue'
import { watch } from 'vue'
// import Multiselect from 'vue-multiselect'
export default {
    name: 'MediaReport',
    components: { Loader },
    data() {
        return {
            moment: moment,
            isTableDataLoader: false,
            selectedPlatform: [],
            platformList: [],
            reportList: [],
            reportMap: {},
            selectedReportType: [],
            interval: 'day',
            widthMapper: {
                'full': 'ui sixteen wide column',
                'half': 'ui eight wide column'
            },
            dateRange: {
                startDate: moment().subtract(1, 'months'),
                endDate: moment()
            },
            singlDatePicker: false,
            prevDateRange: {
                startDate: moment().subtract(2, 'months'),
                endDate: moment().subtract(1, 'months')
            },
            allTablesData: [],
            regex: /^(https?|http):\/\/[^\s/$.?#].[^\s]*$/i,
            specialChar: '',
            loader: false,
            loader1: false,
            current: JSON.parse(localStorage.userData).clients.current,
            isDatePicketTrueAndFalse: true,
            allTableDataKeys: [],
            filterBy: "",
            isFilter: false,
            selectedNumericCampaignValue: "Impressions",
            selectedNumericMatricsValue: "greater than",
            matricsInputValue: "",
            StringMatricsInputValue: "",
            numericFiltersFields: [],
            numericFilterMatrics: [],
            stringFiltersFields: [],
            selectedStringCampaignValue: "SKU id",
            selectedStringMatricsValue: "contains",
            storeNumericFilterValue: [],
            storeStringFilterValue: [],
            isDownload: false
        }
    },

    mounted() {
        for (let [i, d] of this.allTablesData.entries()) {
            $('#table_dynamic_report_' + i).DataTable().destroy()
        }
        this.getTableFilters();

    },
    watch: {
        selectedPlatform(newPlatform) {
            if (newPlatform && newPlatform.value) {
                this.reportTypeList = this.reportMap[newPlatform.value] || [];
                this.selectedReportType = this.reportTypeList[0] || [];
            }
        },
    },

    methods: {
        downloadAccountReport() {
            this.isDownload = true
            let url = "/api/v1/mediareports";
            let payload = {
                'start_date': moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                'end_date': moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                "platform": this.selectedPlatform.value,
                "report_type": this.selectedReportType.value,
                'download': true
            }
            axios.post(url, payload).then(res => {
                this.isDownload = false
                window.location = res.data.data
            }).catch(err => {
                console.log("error", err)
                this.isDownload = false
            })
        },
        checkLink(value) {
            this.regex.test(value)
        },
        formatNumber(num) {
            if (isNaN(num)) return num
            let num1 = Number(num).toFixed(2);
            let num2 = Number(num1).toLocaleString();
            return num2
        },
        getTableData() {
            this.loader1 = true
            this.isTableDataLoader = true
            this.allTablesData = []
            var search = require("@/assets/Icons_SVG/Search.svg");
            let url = "/api/v1/mediareports"
            let payload = {
                'start_date': moment(this.dateRange.startDate).format('YYYY-MM-DD'),
                'end_date': moment(this.dateRange.endDate).format('YYYY-MM-DD'),
                "platform": this.selectedPlatform.value,
                "report_type": this.selectedReportType.value
            }
            axios.post(url, payload).then((response) => {
                this.allTablesData = response.data.data;
                if (response.data.data[0].datepicker == false) {
                    this.isDatePicketTrueAndFalse = false
                }
                this.$nextTick(() => {
                    for (let [i, d] of this.allTablesData.entries()) {
                        $('#table_dynamic_report_' + i).dataTable()
                        $('#table_dynamic_report_' + i).DataTable().destroy()
                        $('#table_dynamic_report_' + i).DataTable({
                            lengthChange: true,
                            info: false,
                            sorting: d.table.sorting == false ? false : [[0, "asc"]],
                            initComplete: function (settings, json) {
                                $('.dataTables_scrollBody tfoot tr').css({ visibility: 'collapse' });
                                $('.dataTables_scrollBody thead tr').css({ visibility: 'collapse' });
                                $('#table_dynamic_report_' + i).wrap("<div style='overflow:auto; width:100%;position:relative;'></div>");
                            },
                            language: {
                                search: "", searchPlaceholder: "Search...", paginate: {
                                    first: "",
                                    previous: "<",
                                    next: ">",
                                    last: "",
                                },
                                lengthMenu: "<h5>Show entries</h5> _MENU_"
                            },
                        })
                        $('#table_dynamic_report_' + i + "_filter > label").append(
                            `<div class='search_icon'><img src='${search}' /></div>`
                        );
                    }
                });
                this.loader1 = false
                this.isTableDataLoader = false
            }).catch(err => {
                this.loader1 = false
                this.isTableDataLoader = false
            })
        },
        getTableFilters() {
            this.loader = true;
            const url = "/api/v1/mediareports/filters";
            const payload = {}

            axios.post(url, payload).then((res) => {
                this.platformList = res.data?.data?.platform || [];
                this.reportMap = res.data?.data?.report_type?.[0] || {};

                if (this.platformList.length) {
                    this.selectedPlatform = this.platformList[0];
                    this.reportTypeList = this.reportMap[this.selectedPlatform.value] || [];
                    this.selectedReportType = this.reportTypeList[0] || null;
                    this.getTableData();
                }
                this.loader = false;
            }).catch((err) => {
                console.error("Error fetching filters data:", err);
                this.loader = false;
            });
        },

        handleApplyFilter() {
            this.getTableData();
        },
        handleIsFilter() {
            const existingValue = this.storeNumericFilterValue.find(
                (item) => item[0].field === this.selectedNumericCampaignValue
            );

            if (existingValue) {
                this.selectedNumericMatricsValue = existingValue[0].operation;
                this.matricsInputValue = existingValue[0].value;
            }
            const existingStringValue = this.storeStringFilterValue.find(
                (item) => item[0].field === this.selectedStringCampaignValue
            );

            if (existingStringValue) {
                this.selectedStringMatricsValue = existingStringValue[0].operation;
                this.StringMatricsInputValue = existingStringValue[0].value;
            }
            this.matricsInputValue = "";
            this.StringMatricsInputValue = "";
            this.isFilter = true;
        },
        clearFilter() {
            this.isFilter = false;
            this.matricsInputValue = "";
            this.StringMatricsInputValue = "";
        },
        removeFilterValue(storeFilterValue, data) {
            const index = storeFilterValue.flat().findIndex((item) => item.field === data.field && item.operation === data.operation && item.value === data.value);

            if (index !== -1) {
                storeFilterValue.splice(index, 1);
            }
        },
        RemoveBadgeValue(data) {
            this.removeFilterValue(this.storeNumericFilterValue, data);

            for (let i = 0; i < this.storeStringFilterValue.length; i++) {
                const itemArray = this.storeStringFilterValue[i];
                const matchIndex = itemArray.findIndex((item) => item.field === data.field && item.operation === data.operation && item.value === data.value);

                if (matchIndex !== -1) {
                    this.storeStringFilterValue.splice(i, 1);
                    break;
                }
            };
            this.getTableData();
        },
        RemoveAllBadgeValue() {
            this.storeNumericFilterValue = [];
            this.storeStringFilterValue = [];
            this.getTableData();
        },
        handleFilterModal(data, storeFilterValue, selectedMatricsValueKey, matricsInputValueKey) {
            if (data.length <= 0) {
                return false;
            }

            let existingValue = storeFilterValue.find(
                (item) => item[0].field === data && item[0].operation === this[selectedMatricsValueKey]
            );

            if (existingValue) {
                // this[selectedMatricsValueKey] = existingValue[0].operation;
                this[matricsInputValueKey] = existingValue[0].value;
            } else {
                this[matricsInputValueKey] = "";
            }
        },
        handleNumericFilterModal(data) {
            this.handleFilterModal(
                data,
                this.storeNumericFilterValue,
                'selectedNumericMatricsValue',
                'matricsInputValue'
            );
        },
        handleStringFilterModal(data) {
            this.handleFilterModal(
                data,
                this.storeStringFilterValue,
                'selectedStringMatricsValue',
                'StringMatricsInputValue'
            );
        },
        handleStringMatricsFilterModal(data) {
            let existingValue = this.storeStringFilterValue.find(
                (item) => item[0].field === this.selectedStringCampaignValue && item[0].operation === data)
            if (existingValue) {
                this.StringMatricsInputValue = existingValue[0].value;
            } else {
                this.StringMatricsInputValue = ""
            }
        },
        handleNumericMatricFilterModal(data) {
            let existingValue = this.storeNumericFilterValue.find(
                (item) => item[0].field === this.selectedNumericCampaignValue && item[0].operation === data)
            if (existingValue) {
                this.matricsInputValue = existingValue[0].value;
            } else {
                this.matricsInputValue = ""
            }
        },
        handlePostFilters({ selectedCampaignValue, selectedMatricsValue, matricsInputValue, storeFilterValue }) {
            if (!matricsInputValue) {
                return false;
            }
            let existingFilter = storeFilterValue.find(
                (item) => item[0].field === selectedCampaignValue && item[0].operation === selectedMatricsValue
            );

            if (existingFilter) {
                existingFilter[0].value = isNaN(matricsInputValue) ? matricsInputValue : parseFloat(matricsInputValue);
            } else {
                storeFilterValue.push([
                    {
                        operation: selectedMatricsValue,
                        field: selectedCampaignValue,
                        value: isNaN(matricsInputValue) ? matricsInputValue : parseFloat(matricsInputValue)
                    }
                ]);
            }
        },
        postNumericalFilters() {
            this.handlePostFilters({
                selectedCampaignValue: this.selectedNumericCampaignValue,
                selectedMatricsValue: this.selectedNumericMatricsValue,
                matricsInputValue: this.matricsInputValue,
                storeFilterValue: this.storeNumericFilterValue,
            });
            this.matricsInputValue = "";
            // this.isFilter = false;
        },
        handlePostStringFilters() {
            if (!this.StringMatricsInputValue) {
                return false;
            }
            this.storeStringFilterValue.push([
                {
                    operation: this.selectedStringMatricsValue,
                    field: this.selectedStringCampaignValue,
                    value: this.StringMatricsInputValue
                }
            ])
            this.StringMatricsInputValue = "";

        },
    }

}